import { FunctionComponent } from 'react'

import { spacing, Stack, Text } from '@cash-design-system/react'

interface Props {
  header?: string | React.ReactNode
  subtitle?: string | React.ReactNode
  children?: string | React.ReactNode
}

export const TilaTextBlock: FunctionComponent<Props> = ({ header, subtitle, children }) => {
  return (
    <Stack space={spacing.xs}>
      {typeof header !== 'undefined' && (
        <Text typography="tabTitle" color="textStandard" as="h3">
          {header}
        </Text>
      )}
      <div>
        {typeof subtitle !== 'undefined' && (
          <Text typography="labelMedium" color="textStandard" as="div">
            {subtitle}
          </Text>
        )}
        {children}
      </div>
    </Stack>
  )
}
